import {HeaderBar} from "../components/header-bar";
import {FooterBar} from "../components/footer-bar";
import {ContentBox} from "../components/content-box";
import styles from "../app.module.scss";
import {Link} from "react-router-dom";

export const PageContact = () => {
  return (
      <>
        <HeaderBar/>
        <ContentBox>
          <h2>Kontakt med Föreningen</h2>

          <div className={styles.row}>
            <div className={styles.colBig}>
              <h3>Ordförande</h3>
              <p><Link to="mailto:ordf@torparangen.se">ordf@torparangen.se</Link></p>

              <h3>Sekreterare</h3>
              <p><Link to="mailto:sekr@torparangen.se">sekr@torparangen.se</Link></p>
              <p>Frågor som styrelsen behöver diskutera eller diskuterat nyligen, motioner till styrelsen, planerade
                möten mm.</p>

              <h3>Kassör</h3>
              <p><Link to="mailto:kassor@torparangen.se">kassor@torparangen.se</Link></p>
              <p>Fråga om betalningar, kostnader och fakturor.</p>
            </div>
            <div className={styles.colSmall}>
              <p>Vill du ha kontakt med föreningen, det kan gälla vad som helst, vänligen skicka e-post
                direkt till den inblandade rollen.</p>
            </div>
          </div>
        </ContentBox>
        <FooterBar/>
      </>
  );
}
